import PageTemplate from "../../components/feature/PageTemplate";
import { homeContent } from "../../mocks/home-content";

export default function Home() {
  return <PageTemplate content={homeContent} />;
}
